import { createReducer, on, Action } from '@ngrx/store';
import { modalErrorShow } from './actions';

export interface State {
  title: string;
  text: string;
  visible: boolean;
}

const initialState: State = {
  title: '',
  text: '',
  visible: false,
};

const _modalErrorReducer = createReducer(
  initialState,
  on(modalErrorShow, (state: State, {
    title,
    text,
  }) => ({ title, text, visible: true })),
);

export function modalErrorReducer(state: typeof initialState = initialState, action: Action) {
  return _modalErrorReducer(state, action);
}
